import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { availabilityShape, bibShape } from '@bibliocommons/bc-prop-types';

export default function FormatChooserSRMessage({ isActive, bib, formatsCount, availability, edition }) {
  const intl = useIntl();
  const bibFormat = bib.getIn(['briefInfo', 'format']);
  const pubDate = bib.getIn(['briefInfo', 'publicationDate']);
  const format = intl.formatMessage({ id: `FORMAT.${bibFormat.toLowerCase()}` });
  const rollUpStatus = availability.get('statusType');
  const status = availability.get('localisedStatus');
  const availabilityLocationType = availability.get('availabilityLocationType');
  const availabilityStatus = intl.formatMessage(
    { id: `circ_${status ? status.toLowerCase() : rollUpStatus.toLowerCase()}` },
    { location: availabilityLocationType }
  );

  const srActiveDesktop = pubDate
    ? intl.formatMessage({ id: 'format_chooser_sr_current_format' }, { format, pubDate, edition, availabilityStatus })
    : intl.formatMessage({ id: 'format_chooser_sr_current_format_no_date' }, { format, edition, availabilityStatus });
  const srOtherDesktop = intl.formatMessage(
    { id: 'format_chooser_sr_also_offer_as' },
    { format, edition, availabilityStatus }
  );

  function renderMessage() {
    if (formatsCount) {
      const srMoreFormat = intl.formatMessage({ id: 'format_chooser_sr_more_formats' }, { count: formatsCount - 1 });
      return `${srActiveDesktop} ${srMoreFormat}`;
    }
    return isActive ? srActiveDesktop : srOtherDesktop;
  }

  return <ScreenReaderMessage className="cp-format-chooser-sr-message">{renderMessage()}</ScreenReaderMessage>;
}

FormatChooserSRMessage.propTypes = {
  bib: bibShape.isRequired,
  availability: availabilityShape.isRequired,
  isActive: PropTypes.bool,
  formatsCount: PropTypes.number,
  edition: PropTypes.string
};
